var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-space-between align-center" },
        [
          _c("h2", { staticClass: "page-title-bar" }, [
            _c("i", { staticClass: "ico ico-multi" }),
            _vm._v(_vm._s(_vm.$t("Button Configuration")) + " ")
          ]),
          _c(
            "v-menu",
            {
              attrs: {
                "offset-y": "",
                "close-on-content-click": false,
                "content-class": "columnMenu"
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "manage-btn btn",
                              attrs: { text: "", small: "" }
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _vm._v(" " + _vm._s(_vm.$t("Manage Columns")) + " "),
                          _c(
                            "v-icon",
                            {
                              class: { rotate: _vm.menuOpen },
                              attrs: { right: "" }
                            },
                            [_vm._v(" mdi-chevron-down ")]
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.menuOpen,
                callback: function($$v) {
                  _vm.menuOpen = $$v
                },
                expression: "menuOpen"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "column-card" },
                [
                  _c("v-card-title", { staticClass: "column-header" }, [
                    _vm._v(" " + _vm._s(_vm.$t("Select Columns")) + " ")
                  ]),
                  _c("v-divider"),
                  _c(
                    "v-list",
                    { staticClass: "select-all", attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c("v-checkbox", {
                            attrs: {
                              "input-value": _vm.isAllSelected,
                              "hide-details": ""
                            },
                            on: { change: _vm.toggleSelectAll }
                          }),
                          _c("v-list-item-title", [
                            _vm._v(" " + _vm._s(_vm.$t("Select All")) + " ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    { staticClass: "column-list" },
                    [
                      _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        _vm._l(_vm.tableHeaders, function(header) {
                          return _c(
                            "v-list-item",
                            { key: header.value },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  value: header.text,
                                  "hide-details": ""
                                },
                                model: {
                                  value: _vm.visibleColumns,
                                  callback: function($$v) {
                                    _vm.visibleColumns = $$v
                                  },
                                  expression: "visibleColumns"
                                }
                              }),
                              _c(
                                "v-list-item-title",
                                { staticClass: "column-text" },
                                [_vm._v(" " + _vm._s(header.text) + " ")]
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    { staticClass: "column-footer" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: {
                            background: "#c57171",
                            color: "#ffffff !important",
                            width: "80px"
                          },
                          attrs: { color: "error", text: "", small: "" },
                          on: {
                            click: function($event) {
                              _vm.menuOpen = false
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          staticStyle: { width: "80px" },
                          attrs: { color: "primary", small: "" },
                          on: {
                            click: function($event) {
                              _vm.menuOpen = false
                              _vm.saveVisibleColumns()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "col-12 pl-0 pb-0 pt-0 pr-0 d-flex",
          staticStyle: { "margin-top": "10px" }
        },
        [
          _c(
            "div",
            {
              staticClass: "pr-0 pt-0",
              class: [_vm.$vuetify.breakpoint.width >= 1375 ? "col-3" : "col-4"]
            },
            [
              _c(
                "v-data-table",
                {
                  staticClass: "tbl-type01 mt-10 products",
                  attrs: {
                    "server-items-length": _vm.totalProducts,
                    headers: _vm.tableHeadersFreeze,
                    "hide-default-footer": true,
                    "item-class": _vm.getRowClass,
                    items: _vm.ButtonConfigTableList,
                    "single-select": true,
                    options: _vm.options,
                    "show-select": "",
                    "item-key": "configName"
                  },
                  on: {
                    "update:options": function($event) {
                      _vm.options = $event
                    },
                    "click:row": _vm.openButtonConfigEditPopup
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.data-table-select",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("v-checkbox", {
                            staticClass: "custom-checkbox ",
                            staticStyle: { height: "40px" },
                            attrs: {
                              value: _vm.selected.includes(item),
                              disabled: item.id === 1
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toggleSelect(item)
                              }
                            }
                          })
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selected,
                    callback: function($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected"
                  }
                },
                [
                  _c("template", { slot: "no-data" }, [
                    _c("p", [
                      _vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")
                    ])
                  ])
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-8 pl-0 pt-0 pr-1",
              class: [_vm.$vuetify.breakpoint.width >= 1375 ? "col-9" : "col-8"]
            },
            [
              _c(
                "v-data-table",
                {
                  staticClass: "tbl-type01 mt-10 tblBorder",
                  attrs: {
                    "server-items-length": _vm.totalProducts,
                    headers: _vm.filteredTableHeaders,
                    "hide-default-footer": true,
                    "item-class": _vm.getRowClass,
                    items: _vm.ButtonConfigTableList,
                    "single-select": true,
                    options: _vm.options,
                    "item-key": "configName"
                  },
                  on: {
                    "update:options": function($event) {
                      _vm.options = $event
                    },
                    "click:row": _vm.openButtonConfigEditPopup
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item.realtimeConfigHibernate",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.realtimeConfigHibernate === true
                                    ? "ON"
                                    : "OFF"
                                ) +
                                " "
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.selected,
                    callback: function($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected"
                  }
                },
                [
                  _c("template", { slot: "no-data" }, [
                    _c("p", [
                      _vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _c("div", { staticClass: "table-options" }, [
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                staticClass: "btn ml-2",
                attrs: { text: "", disabled: _vm.btnDisabledNewDelete },
                on: { click: _vm.openNewButtonConfigPopup }
              },
              [_vm._v(_vm._s(_vm.$t("New")) + " ")]
            ),
            _c(
              "v-btn",
              {
                staticClass: "btn ml-2",
                attrs: {
                  disabled: _vm.btnDisabledNewDelete || _vm.checkSelected,
                  text: ""
                },
                on: { click: _vm.clickDelete }
              },
              [_vm._v(_vm._s(_vm.$t("Delete")) + " ")]
            )
          ],
          1
        )
      ]),
      _c("EditButtonConfig", {
        attrs: {
          selectedItem: _vm.selectedItem,
          dialogPopup: _vm.editDialogPopup
        },
        on: { reload: _vm.reload }
      }),
      _c("AddButtonConfig", {
        attrs: { dialogPopup: _vm.addDialogPopup },
        on: { reload: _vm.reload }
      }),
      _c("a", { ref: "link", style: { display: "none" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }